import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white text-gray-900 px-6">
          <div className="text-center max-w-md">
            <div className="font-display font-extrabold text-3xl mb-3">
              VERTEX<span className="text-crimson">.</span>
            </div>
            <p className="text-gray-500 mb-6">Something went wrong. Please reload the page.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-full bg-crimson text-white font-semibold"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
